/* eslint-disable ember/no-classic-components */
import Component from "@ember/component";
import { fn, hash } from "@ember/helper";
import { action } from "@ember/object";
import { tagName } from "@ember-decorators/component";
import DDateTimeInput from "discourse/ui-kit/d-date-time-input";
import { i18n } from "discourse-i18n";

@tagName("")
export default class DDateTimeInputRange extends Component {
  from = null;
  to = null;
  onChangeTo = null;
  onChangeFrom = null;
  toTimeFirst = false;
  showToTime = true;
  showFromTime = true;
  clearable = false;

  @action
  onChangeRanges(options, value) {
    if (this.onChange) {
      const state = {
        from: this.from,
        to: this.to,
      };

      const diff = {};

      if (options.prop === "from") {
        if (this.to && value?.isAfter(this.to)) {
          diff[options.prop] = value;
          diff["to"] = value.clone().add(1, "hour");
        } else {
          diff[options.prop] = value;
        }
      }

      if (options.prop === "to") {
        if (value && value.isBefore(this.from)) {
          diff[options.prop] = this.from.clone().add(1, "hour");
        } else {
          diff[options.prop] = value;
        }
      }

      const newState = { ...state, ...diff };
      this.onChange(newState);
    }
  }

  <template>
    <div class="d-date-time-input-range" ...attributes>
      <DDateTimeInput
        class="from"
        @date={{this.from}}
        @onChange={{fn this.onChangeRanges (hash prop="from")}}
        @placeholder={{i18n "dates.from_placeholder"}}
        @showTime={{this.showFromTime}}
        @timezone={{@timezone}}
      />

      <DDateTimeInput
        class="to"
        @clearable={{this.clearable}}
        @date={{this.to}}
        @onChange={{fn this.onChangeRanges (hash prop="to")}}
        @placeholder={{i18n "dates.to_placeholder"}}
        @relativeDate={{this.from}}
        @showTime={{this.showToTime}}
        @timeFirst={{this.toTimeFirst}}
        @timezone={{@timezone}}
      />
    </div>
  </template>
}
